export default "__VITE_ASSET__BwOMcxI2__"